var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconXmark = function SvgIconXmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.408 5.416a2.002 2.002 0 0 0-2.83-2.83L12 9.17 5.416 2.592a2.002 2.002 0 0 0-2.83 2.83L9.17 12l-6.578 6.584a2.002 2.002 0 0 0 2.83 2.83L12 14.83l6.584 6.578a2.002 2.002 0 0 0 2.83-2.83L14.83 12z"
  })));
};
export default SvgIconXmark;